export interface DocumentManifest {
  version: number;
  categories: DocumentCategory[];
}

export interface DocumentCategory {
  code: string;
  label: string;
  required: boolean;
  items: DocumentItem[];
}

export interface DocumentItem {
  key: string;
  label: string;
  required?: boolean;
  conditional?: boolean;
  extensions: string[];
  maxMB: number;
}

export interface ProjectDocument {
  id: string;
  project_id: string;
  category: string;
  key: string;
  label: string;
  file_url?: string;
  filename?: string;
  mime_type?: string;
  file_size?: number;
  status: DocumentStatus;
  note?: string;
  uploaded_by?: string;
  uploaded_at?: string;
  verified_by?: string;
  verified_at?: string;
  required: boolean;
  conditional: boolean;
}

export enum DocumentStatus {
  MISSING = 'MISSING',
  UPLOADED = 'UPLOADED',
  VERIFIED = 'VERIFIED',
  REJECTED = 'REJECTED'
}

export interface DocumentCompletion {
  requiredTotal: number;
  requiredDone: number;
  optionalDone: number;
  percent: number;
}

export interface DocumentUploadData {
  category: string;
  key: string;
  file: File;
}

export interface DocumentVerificationData {
  status: DocumentStatus.VERIFIED | DocumentStatus.REJECTED;
  note?: string;
}